import { z } from "zod";
import { shipmentTagSchema } from "../hooks/react-query/useInboundUrgentAndCriticalCare";
import { equipmentTypeMap } from "./equipment.type";

const DeliveryEquipmentTypeSchema = z.union([
  z.literal(equipmentTypeMap.trailer),
  z.literal(equipmentTypeMap.straightTruck),
]);

export const oldRouteSchema = z.object({
  id: z.number(),
  name: z.string(),
  sicId: z.number().optional().default(0),
  zones: z.array(z.string()),
  zoneIds: z.number().array().nullish().default([]),
  zipCodes: z.array(z.string()),
  startPoint: z.string().optional(),
  startTime: z.string().nullable().default(""),
  endPoint: z.string().nullable(),
  endTime: z.string().nullish().default(""),
  trailerId: z.number().nullable(),
  tractorId: z.number().nullable(),
  straightTruckId: z.number().nullable(),
  equipmentType: DeliveryEquipmentTypeSchema.nullish(),
  doorId: z.number().optional().default(0),
  driverId: z.number().optional().default(0),
  isActive: z.boolean().default(false),
  hereFeatureId: z.string().nullable(),
  isRoute: z.boolean().default(true),
});

export const OldRoutesSchema = z.array(oldRouteSchema);
export type OldRoute = z.infer<typeof oldRouteSchema>;

const zipCodeSchema = z.object({
  zipCodeId: z.number(),
  zipCode: z.string(),
  shipmentTags: z.array(shipmentTagSchema).nullable(),
});

const routeSchema = z.object({
  id: z.number(),
  name: z.string(),
  sicId: z.number().optional().default(0),
  zones: z.array(z.string()),
  zoneIds: z.number().array().nullish().default([]),
  startPoint: z.string().optional(),
  startTime: z.string().nullable().default(""),
  endPoint: z.string().nullable(),
  endTime: z.string().nullish().default(""),
  trailerId: z.number().nullable(),
  tractorId: z.number().nullable(),
  straightTruckId: z.number().nullable(),
  equipmentType: DeliveryEquipmentTypeSchema.nullish(),
  doorId: z.number().optional().default(0),
  driverId: z.number().nullable().default(0),
  isActive: z.boolean().default(false),
  hereFeatureId: z.string().nullable(),
  isRoute: z.boolean().default(true),
  zipCodes: z.array(zipCodeSchema),
});

export const routesSchema = z.array(routeSchema);
export type Route = z.infer<typeof routeSchema>;
// Update route (usePresetRoutes.ts useEditPresetRoute) won't update Zip Codes.
// Therefore we omit the zipCodes field.
const updateRouteSchema = oldRouteSchema.omit({ zipCodes: true });
export type UpdateRoute = z.infer<typeof updateRouteSchema>;

const routeV3Schema = z.object({
  id: z.number(),
  sicId: z.number(),
  zones: z.array(z.string()),
  zoneIds: z.array(z.number()),
  startTime: z.string().nullable(),
  endPoint: z.string().nullable(),
  endTime: z.string().nullable(),
  trailerId: z.number().nullable(),
  tractorId: z.number().nullable(),
  straightTruckId: z.number().nullable(),
  equipmentType: DeliveryEquipmentTypeSchema.nullish(),
  doorId: z.number(),
  doorAssignment: z.number(),
  driverId: z.number(),
  isRoute: z.boolean(),
  isActive: z.boolean(),
  name: z.string(),
  hereFeatureId: z.string().nullable(),
});

export const routeV3ArraySchema = z.array(routeV3Schema);
export type RouteV3 = z.infer<typeof routeV3Schema>;
